var React = require('react');

function ToolsInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.06 23.06a1.5 1.5 0 0 1-2.121-2.12l6.571-6.573 2.121 2.122zM6.451 13.306l4.24 4.243M19.91 4.101L8.572 15.428M21.785 4.359a1 1 0 0 1-1.508.109l-.812-.811a1 1 0 0 1 .135-1.529L21.816.589a.5.5 0 0 1 .639.057l.9.9a.5.5 0 0 1 .045.654zM11.586 9.586l-3.44-3.44A4 4 0 0 0 4.5.5a4.049 4.049 0 0 0-.822.084.5.5 0 0 0-.251.843l1.427 1.427A.5.5 0 0 1 5 3.207V4.5a.5.5 0 0 1-.5.5H3.207a.5.5 0 0 1-.353-.146L1.427 3.427a.5.5 0 0 0-.843.251A4.049 4.049 0 0 0 .5 4.5a4 4 0 0 0 5.646 3.646l3.44 3.44M14.414 12.414l3.44 3.44A4 4 0 0 1 23.5 19.5a4.049 4.049 0 0 1-.084.822.5.5 0 0 1-.843.251l-1.427-1.427a.5.5 0 0 0-.353-.146H19.5a.5.5 0 0 0-.5.5v1.293a.5.5 0 0 0 .146.353l1.427 1.427a.5.5 0 0 1-.251.843 4.049 4.049 0 0 1-.822.084 4 4 0 0 1-3.646-5.646l-3.44-3.44"}));
}

ToolsInline.defaultProps = {"className":"stroke","viewBox":"0 0 24 24"};

module.exports = ToolsInline;

ToolsInline.default = ToolsInline;
